<div class="app-hea-car">
  <!-- <a class="app-hea-car__close" (click)="">x zamknij okno</a> -->
  <div class="app-hea-car__con" [ngClass]="{ 'app-hea-car__con': accountOrders().length }">
    @for (e of accountOrders(); track $index) {
      <div class="app-hea-car__con__ord">
        <img class="app-hea-car__con__ord__img" [src]="e.photo" />
        <div class="app-hea-car__con__ord__text">
          <label>SZKOLENIE</label>
          <p>
            {{ e.name }}
          </p>
          <label>DATA</label>
          <p>
            {{ e.start_date | date: 'dd/MM/yyyy' }}&nbsp;|&nbsp;{{ e.start_date | date: 'HH:mm' }} -
            {{ e.end_date | date: 'HH:mm' }}
          </p>

          @if (e.place) {
            <label>MIEJSCE</label>
            <p>{{ e.place.city }}, {{ e.place.address }}, {{ e.place.name }}</p>
          }
          <label>ILOŚĆ BILETÓW</label>
          <div class="app-hea-car__con__ord__text__tickets">
            <a class="remove" [ngClass]="{ inactive: e.places <= 1 }" (click)="removePlace(e)">-</a>
            <p>{{ e.places }}</p>
            <a class="add" [ngClass]="{ inactive: e.places === e.free_seats }" (click)="addPlace(e)">+</a>
          </div>

          <label>CENA</label>
          @if (e.price === 0) {
            <p>Szkolenie bezpłatne</p>
          } @else {
            @if (user()) {
              <p>
                <s>{{ e.price + ' PLN' }}</s
                >&nbsp;{{
                  user()?.type === UserType.MEMBER
                    ? (e.price * 0.9 | mask: 'separator.2') + ' PLN'
                    : (e.price * 0.8 | mask: 'separator.2') + ' PLN'
                }}
              </p>
            } @else {
              <p>{{ e.price > 0 ? e.price + ' PLN' : 'Szkolenie bezpłatne' }}</p>
            }
          }

          <div class="row mt-2">
            <div class="col-12 d-flex justify-content-end">
              <a class="app-hea-car__con__ord__text__rm" (click)="removeEvent(e)">USUŃ Z KOSZYKA</a>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  @if (accountOrders().length) {
    <div class="app-hea-car__sum">
      <div>
        <label>SUMA ŁĄCZNA</label>
        <p>{{ summPrice() ? (summPrice()! | mask: 'separator.2') + ' PLN' : '0 PLN' }}</p>
      </div>
      <div>
        @if (user()) {
          <label>RABAT {{ user()!.type === UserType.ELITE ? 'ELITE' : 'MEMBER' }}</label>
          <p>
            {{ user()!.type === UserType.ELITE ? '20%' : '10%' }}
          </p>
        }
      </div>
    </div>

    <div class="app-hea-car__go-car">
      <a
        class="app-hea-car__go-car__btn"
        [routerLink]="['/', wwwRouteSlug.ACCOUNT, wwwRouteSlug.ORDERS]"
        appGtmClick
        [layer]="{
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'main menu cart',
          eventAction: 'select::go to checkout',
          eventLabel: 'go to checkout::' + '/' + wwwRouteSlug.ACCOUNT + wwwRouteSlug.ORDERS,
          event_name: 'body_button_click',
          module_name: 'go to checkout',
          cta_name: 'go to checkout',
          link_url: '/' + wwwRouteSlug.ACCOUNT + wwwRouteSlug.ORDERS,
        }"
      >
        Przejdź do realizacji rezerwacji
      </a>
    </div>

    <div class="row">
      <div class="col-12 d-flex justify-content-center">
        <p class="text-center app-hea-car__sup">potrzebujesz wsparcia z zamówieniem?</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-center">
        <a class="app-hea-car__contact" [routerLink]="['/', wwwRouteSlug.CONTACT]"> SKONTAKTUJ SIĘ Z NAMI</a>
      </div>
    </div>
  } @else {
    <p class="text-center my-3">Brak produktów w koszyku</p>
  }
</div>
